var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rect skelet-anim",style:({
      height: _vm.height + 'px',
      maxWidth: _vm.width + 'px',
      width: '100%',
      marginBottom: _vm.marginBottom + 'px'
    })})}
var staticRenderFns = []

export { render, staticRenderFns }